import React from 'react';
import DropdownItem from '@/components/DropdownItem';
import { dictionaryReportTypes } from '../../reports/constants';

const DataManagementDictionaryTools = ({
  allowConversion,
  convert,
  dictionaryCode,
  dictionaryName,
  disableConvert,
  disableValidate,
  showReports,
  validate,
}) => (
  <>
    <DropdownItem
      icon="play"
      textId="actions.validate.dictionary.row"
      onClick={() => (validate({ dictionaryCode }))}
      disabled={disableValidate}
    />
    <DropdownItem
      icon="history"
      textId="actions.validation.reports.dictionary.row"
      onClick={() => (showReports({ name: dictionaryName, reportType: dictionaryReportTypes.VALIDATION }))}
      disabled={disableValidate}
    />
    {allowConversion && (
      <>
        <DropdownItem
          icon="arrow alternate circle right"
          textId="actions.convert.dictionary.row"
          onClick={() => (convert({ dictionaryCode, dictionaryName }))}
          disabled={disableConvert}
        />
        <DropdownItem
          icon="history"
          textId="actions.conversion.reports.dictionary.row"
          onClick={() => (showReports({ name: dictionaryName, reportType: dictionaryReportTypes.CONVERSION }))}
          disabled={disableConvert}
        />
      </>
    )}
  </>
);

export default DataManagementDictionaryTools;
